export function fetchEventSource(url, { messageCallback, errorCallback }) {
  // 创建一个新的EventSource对象
  const eventSource = new EventSource(url);

  // 当成功连接到SSE服务器时触发
  eventSource.onopen = function (e) {
    console.log(e);
  };

  // 当接收到新的消息（一般是服务器推送过来的数据）时触发，message是包含消息数据的对象
  eventSource.onmessage = function (e) {
    const data = e.data;
    messageCallback && messageCallback(data);
  };

  // 如果连接出现错误，比如网络问题等触发
  eventSource.onerror = function (e) {
    errorCallback && errorCallback(e);
    // 可以根据具体情况选择是否尝试重新连接等操作
  };
}

export function fetchEventSourceWithHeaders(url, headers, { messageCallback, errorCallback, completeCallback }) {
  const requestOptions = {
    method: 'GET',
    headers,
    redirect: 'follow',
  };

  fetch(url, requestOptions).then((response) => {
    const reader = response.body.getReader();
    reader.read().then(function processText({ done, value }) {
      if (done) {
        console.log('done');
        completeCallback && completeCallback();
        return;
      }
      // console.log(new TextDecoder().decode(value));
      messageCallback && messageCallback(new TextDecoder().decode(value));
      return reader.read().then(processText);
    });
  }).catch((error) => {
    console.log('error', error);
    errorCallback && errorCallback();
  });
}

